/**
 * @namespace Foundation.Login
 */
Foundation.Login = window["Foundation"]["Login"] = {};

/**
 * The TTL to use for "stay logged in" ("remember me") tokens.
 * @const
 */
Foundation.Login.STAY_LOGGED_IN_TTL = 8.5 * 24 * 60 * 60;  // 8.5 days

/**
 * The TTL to use for session cookie tokens.
 * @const
 */
Foundation.Login.SESSION_COOKIE_TTL = 36 * 60 * 60;  // 1.5 days


/**
 * Handle the expiration of the login.
 * @private
 */
Foundation.Login.expiration = function () {
    var spinner = new Foundation.View.Spinner();
    Foundation.Session.Manager.sharedInstance().logOut().then(function () {
        spinner.hide();
        window.alert("Your session has expired. You'll now be prompted to log in again.");
        new Foundation.Login.Dialog();
    });
};

/**
 * Create a new expiration timer and hook up the expiration handler.
 * @private
 * @param {number} seconds
 */
Foundation.Login.startExpirationTimer = function (seconds) {
    var timer = new Foundation.Timer.Persistent("login-expiration", seconds * 1000);
    timer.then(Foundation.Login.expiration);
};

/**
 * Setup function. Gets called at the end of this file.
 * @private
 */
Foundation.Login.init = function () {
    var sessionManager = Foundation.Session.Manager.sharedInstance();
    var expirationTimer = Foundation.Timer.Persistent.timerForId("login-expiration");
    
    if (expirationTimer) {
        // Watch the persistent login expiration timer.
        expirationTimer.then(Foundation.Login.expiration);
        
        // Cancel persistent timer if we are not logged in.
        if (!sessionManager.isAuthenticated()) expirationTimer.cancel();
    }
};

// ---------------------------------------------------------------------

Foundation.Login.init();

